// Module
var code = "<a class=\"text-sm sps-btn sps-btn-ghost btn-color-favorite toggle-favourites\" data-bind=\"style: _style\"> <i class=\"fa fa-star transition\"></i> </a>";
// Exports
export default code;